import { useEffect, useRef } from 'react';

import styles from '../../styles/modules/game/Game.module.scss';

import imgTitle from '../../assets/images/game/title.webp';

import GameFeeds from './GameFeeds';

import hintImg from '../../assets/images/game/game_img.webp';

import { useAnimation } from '../../hooks/useAnimation';
import { useGameStore } from '../../store/useGameStore';

const PLAYER_ANIMATIONS = {
	1: 'shot_top',
	2: 'shot_center',
	3: 'shot_bottom',
};

const Game = () => {
	const turkeyRef = useRef(null);

	const { animation, switchAnimation } = useGameStore();

	const turkey = useAnimation({
		ref: turkeyRef,
		name: 'turkey',
		viewport: {
			width: 580 * 1.5,
			height: 290 * 1.5,
			x: -650,
			y: -100,
		},
	});

	useEffect(() => {
		if (!turkey) return;

		let timerId = null;

		if (animation) {
			turkey.setAnimation(PLAYER_ANIMATIONS[animation]);

			timerId = setTimeout(() => {
				switchAnimation(null);
				turkey.setAnimation('idle');
			}, 700);
		}

		return () => {
			if (timerId) clearTimeout(timerId);
		};
	}, [animation, switchAnimation, turkey]);

	return (
		<div className={styles.container}>
			<div className={styles.title}>
				<img src={imgTitle} alt='' />
			</div>

			<div className={styles.inner}>
				<div className={styles.bridge} />

				<div className={styles.player}>
					<div className='player-container' id='player-container' ref={turkeyRef} />
				</div>

				<GameFeeds />

				<div className={styles.hint}>
					<img src={hintImg} alt='' />
				</div>
			</div>
		</div>
	);
};

export default Game;
